var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/engine-user-agent.js
// module id = 450
// module chunks = 0